import React, { createContext, useContext, useState, useEffect } from 'react';
import accountService from '../services/accountService';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    initAuth();
  }, []);

  const initAuth = async () => {
    if (accountService.isAuthenticated()) {
      try {
        const validatedUser = await accountService.validateToken();
        if (validatedUser) {
          setUser(validatedUser);
        } else {
          accountService.clearAuth();
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
        accountService.clearAuth();
      }
    }
    setLoading(false);
    setInitialized(true);
  };

  const login = async (email, password) => {
    const user = await accountService.login(email, password);
    setUser(user);
    return user;
  };

  const register = async (email, password, firstName, lastName) => {
    const result = await accountService.register(email, password, firstName, lastName);
    return result;
  };

  const logout = async () => {
    await accountService.logout();
    setUser(null);
  };

  const value = {
    user,
    loading,
    initialized,
    isAuthenticated: !!user,
    login,
    register,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
